import { render, staticRenderFns } from "./CerrarSorteoManual.vue?vue&type=template&id=b306f0b2&scoped=true&dark=true"
import script from "./CerrarSorteoManual.vue?vue&type=script&lang=js"
export * from "./CerrarSorteoManual.vue?vue&type=script&lang=js"
import style0 from "./CerrarSorteoManual.vue?vue&type=style&index=0&id=b306f0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b306f0b2",
  null
  
)

export default component.exports